module.exports = __webpack_public_path__ + "img/ermunro.7d1f2bf2.png";